import { render, staticRenderFns } from "./MonthOfActs.vue?vue&type=template&id=1bf0f9b9&scoped=true&lang=pug&"
import script from "./MonthOfActs.vue?vue&type=script&lang=js&"
export * from "./MonthOfActs.vue?vue&type=script&lang=js&"
import style0 from "./MonthOfActs.vue?vue&type=style&index=0&id=1bf0f9b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf0f9b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VContainer})
